import { OrganizationApi } from "@/api";

export async function getAll() {
  const { data } = await OrganizationApi.getAll();
  return data;
}
